import React from 'react';
import Table from 'components/Table';
import byteSize from 'byte-size';

const ResultStats = ({ results, loading, globalFilter }) => {
  const statsColumns = [
    {
      title: 'Segment',
      dataIndex: 'segmentId',
      render: (value) => {
        const option = globalFilter?.filterSegments.find(o => o.id === value);
        return option?.title || option?.segment?.title || value;
      },
    },
    {
      title: 'Rows',
      dataIndex: ['statistics', 'rows'],
      type: 'number',
    },
    {
      title: 'Rows before limit',
      dataIndex: ['statistics', 'rowsBeforeLimitAtLeast'],
      type: 'number',
    },
    {
      title: 'Elapsed',
      dataIndex: ['statistics', 'elapsed'],
      type: 'number',
      render: (value) => `${value}s`,
    },
    {
      title: 'Rows read',
      dataIndex: ['statistics', 'rowsRead'],
      type: 'number',
    },
    {
      title: 'Bytes read',
      dataIndex: ['statistics', 'bytesRead'],
      type: 'number',
      render: (size) => size && byteSize(size)?.toString(),
    },
    {
      title: 'Bytes transferred',
      dataIndex: ['statistics', 'transferred'],
      type: 'number',
      render: (size) => size && byteSize(size)?.toString(),
    },
  ];

  return (
    <Table
      rowKey="segmentId"
      loading={loading}
      columns={statsColumns}
      dataSource={results}
    />
  );
};

export default ResultStats;
